const sectionFaqGridCss = `
[data-type='section-faq-grid'] * {
  box-sizing: border-box;
}

[data-type='section-faq-grid'] .faq-grid-container-fluid {
  padding: 40px 0;
}

[data-type='section-faq-grid'] .faq-grid-container-fluid .title-faq-grid {
  font-size: 28px;
  text-align: center;
  margin-bottom: 30px !important;
  font-weight: 700 !important;
}

[data-type='section-faq-grid'] .list-item {
  display: flex;
  flex-wrap: wrap;
  row-gap: 15px;
  column-gap: 40px;
}

[data-type='section-faq-grid'] .list-item .item-wapper {
  width: calc((100% - 40px) / 2);
  overflow: hidden;
  border-radius: 10px;
  height: fit-content;
}

[data-type='section-faq-grid'] .list-item .item-wapper .item-question {
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  cursor: pointer;
}

[data-type='section-faq-grid'] .list-item .item-wapper .item-question .title-item-question {
  width: calc(100% - 40px);
  padding: 0 10px;
  text-align: center;
  font-size: 16px;
  margin: 0 !important;
}

[data-type='section-faq-grid'] .list-item .item-wapper .item-question span {
  display: flex;
}

[data-type='section-faq-grid'] .list-item .item-wapper .item-question span svg {
  width: 20px;
  height: 20px;
}

[data-type='section-faq-grid'] .list-item .item-wapper [data-attribute='item-answer'] {
  border-top: solid 1px #ffffff;
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
}

[data-type='section-faq-grid'] .list-item .item-wapper [data-attribute='item-answer'] .answer-content {
  padding: 15px;
}

@container (max-width: 768px) {
  [data-type='section-faq-grid'] .faq-grid-container-fluid {
    padding: 16px 0;
  }

  [data-type='section-faq-grid'] .faq-grid-container-fluid .title-faq-grid {
    font-size: 16px;
    line-height: 24px;
  }

  [data-type='section-faq-grid'] .list-item .item-wapper {
    width: 100%;
  }
}
`;

export default sectionFaqGridCss;
